<template>
  <div>
    <QForm @submit.prevent="onSubmitFinanceDetails">
      <QExpansionItem
        :label="labelFinanceDetails"
        :header-style="{
          color: 'var(--primary-color)',
          fontWeight: 500,
          paddingLeft: '0px',
          borderBottom: '1px solid #ccc8c8',
          marginBottom: '20px'
        }"
        :disable="disableCollapse"
        v-model="openFinanceDetails"
      >
        <div class="row">
          <!-- <InputField label="Current Fleet Size" v-model="entityDetails.fleetSize" :minLength="1" :maxLength="3" type="number" /> -->
          <InputField
            label="Current number of business vehicles"
            v-model="entityDetails.fleetSize"
            :minLength="1"
            :maxLength="3"
            type="number"
          />
          <InputField label="Number of Employees" v-model="entityDetails.numberEmployees" :minLength="1" :maxLength="4" type="number" />
        </div>
        <div class="q-pa-xs">
          <label class="field-label"
            >Are you planning on leasing more vehicles in the next 6 months?*
            <img
              src="/assets/icons/small-info.svg"
              :style="convertColourComputed ? convertColourComputed : ''"
              style="top: 3px; position: relative; cursor: pointer"
              title="If you may be considering more vehicles in the next 6 months, but are unsure select 'Yes', as this may avoid the need for multiple credit applications."
              @click="onPlanInfo()"
            />

            <!-- <img
              src="/assets/icons/small-info.svg"
              style="top: 3px; position: relative; cursor: pointer"
              title="If you may be considering more vehicles in the next 6 months, but are unsure select 'Yes', as this may avoid the need for multiple credit applications."
              @click="onPlanInfo()"
            /> -->
          </label>
          <label class="block q-pb-xs">
            <QRadio v-model="entityDetails.purchasingMore" val="yes" label="Yes" />
            <QRadio v-model="entityDetails.purchasingMore" val="no" label="No" />
          </label>
          <div>
            <label class="field-label">How many vehicles are you planning on leasing to grow your fleet?*</label>
            <div
              style="text-align: center; padding-top: 25px; padding-bottom: 25px; border-radius: 10px; margin-top: 10px"
              class="row justify-center blue-box"
            >
              <div class="col-xs-2 col-sm-1 col-md-1 self-center">
                <QBtn
                  color="primary"
                  no-caps
                  label="-"
                  round
                  @click="entityDetails.vehicleNumber > 1 ? entityDetails.vehicleNumber-- : 0"
                />
              </div>
              <div class="col-xs-4 col-sm-2 col-md-2 self-center">
                <h5 style="background-color: white; border-radius: 25px; padding: 10px 0; margin: 0 15px">
                  {{ entityDetails.vehicleNumber }}
                </h5>
              </div>
              <div class="col-xs-2 col-sm-2 col-md-1 self-center">
                <QBtn color="primary" no-caps round label="+" @click="entityDetails.vehicleNumber++" />
              </div>
            </div>
            <hr />
            <div class="blue-box">
              <!-- new Text -->
              <p>Your credit limit should be reflective of the number of vehicles you wish to lease within the next 6 months.</p>
              <label class="field-label">Credit Limit Requested*</label>
              <h5>{{ currencyFormatter(entityDetails.applicationValue) }}</h5>
              <QSlider
                :value="entityDetails.applicationValue"
                @change="
                  (val) => {
                    entityDetails.applicationValue = val;
                  }
                "
                :min="minValue"
                :step="step"
                :max="maxValue"
              />
              <div style="padding-bottom: 35px">
                <span style="float: left">{{
                  currencyFormatter(
                    scoreboard && scoreboard.leaseDetails && scoreboard.leaseDetails.fiscalValue
                      ? scoreboard.leaseDetails.fiscalValue
                      : scoreboard && scoreboard.leaseDetails && scoreboard.leaseDetails.driveAwayPrice
                      ? scoreboard.leaseDetails.driveAwayPrice
                      : 0
                  )
                }}</span>
                <span style="float: right">{{ currencyFormatter(maxValue) }}</span>
              </div>
              <QCheckbox
                label="Yes, if eligible I am interested in applying for a maximum credit amount of up to $300,000"
                v-model="entityDetails.maximum"
                v-if="entityDetails && entityDetails.applicationValue < 300000"
              />
            </div>
            <br />
          </div>
          <div
            style="padding: 15px; background-color: var(--primary-color-background); margin-bottom: 20px; border-radius: 10px"
            v-if="entityDetails.applicationValue >= 300000"
          >
            <div class="q-mt-md">
              <p>
                Please upload business financial statements to support your credit limit request
                <img
                  src="/assets/icons/small-info.svg"
                  :style="convertColourComputed ? convertColourComputed : ''"
                  style="top: 3px; position: relative; cursor: pointer"
                  @click="onFileUploadInfo"
                />
                <!-- <img src="/assets/icons/small-info.svg" style="top: 3px; position: relative; cursor: pointer" @click="onFileUploadInfo" /> -->
              </p>
              <QFile
                :disable="disableFileInput"
                bg-color="grey-1"
                filled
                @input="onUpload"
                :loading="fileUploadLoading"
                label="Select documents (PDF, Word or Excel)"
                accept=".pdf, .doc, .docx, .xls, .xlsx"
                max-file-size="10240000"
                @rejected="onRejected"
              >
                <template v-slot:prepend>
                  <QAvatar>
                    <i class="uiw-font-upload" style="width: 24px; color: var(--primary-color)" />
                    <!-- <img src="/assets/icons/upload.svg" style="width: 24px" /> -->
                  </QAvatar>
                </template>
              </QFile>
            </div>
            <div class="q-mt-md" v-if="entityDetails && entityDetails.fileUrls && entityDetails.fileUrls.length">
              <div v-for="fileItem in entityDetails.fileUrls" :key="fileItem.uuid" style="padding: 10px 30px; background-color: white">
                [{{ fileItem.fileName }}]
                <i
                  class="uiw-font-trash-2"
                  style="top: 3px; float: right; position: relative; cursor: pointer; color: var(--primary-color)"
                  alt="Remove"
                  title="Remove"
                  @click="removeFileItem(fileItem.uuid)"
                />
                <!--  <img
                  src="/assets/icons/trash-2.svg"
                  style="top: 3px; float: right; position: relative; cursor: pointer"
                  alt="Remove"
                  title="Remove"
                  @click="removeFileItem(fileItem.uuid)"
                /> -->
              </div>
            </div>
          </div>
        </div>

        <SubHeader v-if="!isSoleTrader" header="Personal Guarantee" info="yes" dialog="PersonalGuarantee" />
        <p v-if="!isSoleTrader">Please indicate whether you will be providng a personal guarantee as part of this application.</p>
        <!-- <p v-else>
          Personal guarantee is required as part of this application. Please
          confirm the below.
        </p> -->
        <label class="block q-pb-xs" v-if="!isSoleTrader">
          <QRadio
            v-model="entityDetails.personallyGuarantee"
            val="yes"
            label="Yes, I will provide a personal guarantee."
            class="green full-width"
          />
        </label>
        <label class="block" v-if="!isSoleTrader">
          <QRadio
            v-model="entityDetails.personallyGuarantee"
            val="no"
            label="No, I won’t be providing a personal guarantee."
            class="red full-width"
          />
        </label>

        <div
          style="
            padding: 15px;
            background-color: var(--primary-color-background);
            margin-top: 10px;
            margin-bottom: 20px;
            border-radius: 10px;
          "
          v-if="entityDetails.personallyGuarantee == 'no' && isPersonallyGuaranteeApproved && entityDetails.applicationValue < 300000"
        >
          <div class="q-mt-md">
            <p>
              Please upload business financial statements to support your credit limit request
              <img
                src="/assets/icons/small-info.svg"
                :style="convertColourComputed ? convertColourComputed : ''"
                style="top: 3px; position: relative; cursor: pointer"
                @click="onFileUploadInfo"
              />
              <!-- <img src="/assets/icons/small-info.svg" style="top: 3px; position: relative; cursor: pointer" @click="onFileUploadInfo" /> -->
            </p>
            <QFile
              :disable="disableFileInput"
              bg-color="grey-1"
              filled
              @input="onUpload"
              :loading="fileUploadLoading"
              label="Select documents (PDF, Word or Excel)"
              accept=".pdf, .doc, .docx, .xls, .xlsx"
              max-file-size="10240000"
              @rejected="onRejected"
            >
              <template v-slot:prepend>
                <QAvatar>
                  <i class="uiw-font-upload" style="width: 24px; color: var(--primary-color)" />
                  <!-- <img src="/assets/icons/upload.svg" style="width: 24px" /> -->
                </QAvatar>
              </template>
            </QFile>
          </div>
          <div class="q-mt-md" v-if="entityDetails && entityDetails.fileUrls && entityDetails.fileUrls.length">
            <div v-for="fileItem in entityDetails.fileUrls" :key="fileItem.uuid" style="padding: 10px 30px; background-color: white">
              [{{ fileItem.fileName }}]
              <i
                class="uiw-font-trash-2"
                style="top: 3px; float: right; position: relative; cursor: pointer; color: var(--primary-color)"
                alt="Remove"
                title="Remove"
                @click="removeFileItem(fileItem.uuid)"
              />
              <!--  <img
                  src="/assets/icons/trash-2.svg"
                  style="top: 3px; float: right; position: relative; cursor: pointer"
                  alt="Remove"
                  title="Remove"
                  @click="removeFileItem(fileItem.uuid)"
                /> -->
            </div>
          </div>
        </div>
        <div class="q-pt-lg q-pb-sm text-center">
          <QBtn color="primary" no-caps label="Next" type="submit" :disable="financeDetailsFields" :loading="loading" /><br /><br />
          <QBtn color="primary" flat no-caps label="Save & Close" :loading="saveLoading" @click="saveAndClose()" />
        </div>
      </QExpansionItem>
    </QForm>
    <FinanceDetailsDialog v-if="showFinanceDetailsDialog" @closeFinanceDetailsDialog="closeFinanceDetailsDialog" />
  </div>
</template>

<script>
import { QBtn, QForm, QRadio, QSelect, QCheckbox, QSlider, QExpansionItem, QFile, QAvatar } from 'quasar';
import { mapState, mapActions } from 'vuex';
import InputField from '@/components/Atoms/InputField.vue';
import SectionHeader from '@/components/Atoms/SectionHeader';
import SubHeader from '@/components/Atoms/SubHeader';
import MutateCreateOrUpdateProperty from '@/graphql/mutations/MutateCreateOrUpdateProperty';
import MutateGetSignedUrl from '@/graphql/mutations/MutateGetSignedUrl';
import MutateGetFileByUUID from '@/graphql/mutations/MutateGetFileByUUID';
import FinanceDetailsDialog from '@/components/Molecules/FinanceDetailsDialog.vue';
import { GLOBAL_ERROR } from '@/components/GlobalError/GlobalError';
import { GlobalDialog } from '@/components/Dialogs/GlobalDialog';
import ColoureMixins from '@/mixins/ColourMixins.js';

export default {
  name: 'CalculatorFinanceDetails',
  components: {
    SubHeader,
    InputField,
    QForm,
    QCheckbox,
    QBtn,
    QRadio,
    QSlider,
    QExpansionItem,
    FinanceDetailsDialog,
    QFile,
    QAvatar
  },
  props: ['disableCollapse', 'openCollapse'],
  mixins: [ColoureMixins],
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard
    }),
    disableFileInput() {
      if (this.entityDetails && this.entityDetails.fileUrls && this.entityDetails.fileUrls.length > 9) return true;
      else return false;
    },
    financeDetailsFields() {
      if (this.entityDetails.purchasingMore && (this.entityDetails.personallyGuarantee || this.isSoleTrader)) return false;
      else return true;
    },
    convertColourComputed() {
      return this.convertColour();
    },
    entityType() {
      if (
        this.scoreboard &&
        this.scoreboard.entityDetails &&
        (this.scoreboard.entityDetails.entityType == 'IND' || this.scoreboard.entityDetails.entityType == 'Sole_Trader')
      )
        return 'IND';
      return null;
    },
    isSoleTrader() {
      return this.entityType === 'IND' ? true : false;
    }
  },
  created() {
    if (this.scoreboard && this.scoreboard.businessDetails && this.scoreboard.businessDetails.financeDetails) {
      this.entityDetails.fleetSize = this.scoreboard.businessDetails.financeDetails.currentFleetSize;
      this.entityDetails.numberEmployees = this.scoreboard.businessDetails.financeDetails.numberOfEmployees;
      this.entityDetails.purchasingMore = this.scoreboard.businessDetails.financeDetails.purchaseMoreVehicles;
      this.entityDetails.vehicleNumber = this.scoreboard.businessDetails.financeDetails.howManyVehicles;
      this.entityDetails.applicationValue = this.scoreboard.businessDetails.financeDetails.valueOfApplication;
      this.entityDetails.maximum = this.scoreboard.businessDetails.financeDetails.maximum;
      this.entityDetails.personallyGuarantee = this.scoreboard.businessDetails.financeDetails.personalGuarantee;
      if (this.scoreboard.businessDetails.financeDetails.fileUrls && this.scoreboard.businessDetails.financeDetails.fileUrls.length) {
        for (var i = 0; i < this.scoreboard.businessDetails.financeDetails.fileUrls.length; i++) {
          this.entityDetails.fileUrls.push({
            uuid: this.scoreboard.businessDetails.financeDetails.fileUrls[i].uuid,
            fileName: this.scoreboard.businessDetails.financeDetails.fileUrls[i].fileName,
            mimeType: this.scoreboard.businessDetails.financeDetails.fileUrls[i].mimeType
          });
        }
      }
    } else if (this.scoreboard && this.scoreboard.leaseDetails && this.scoreboard.leaseDetails.fiscalValue) {
      this.entityDetails.applicationValue = this.scoreboard.leaseDetails.fiscalValue;
      this.minValue = this.scoreboard.leaseDetails.fiscalValue - (500000 - this.scoreboard.leaseDetails.fiscalValue) * 0.1;
    } else if (this.scoreboard && this.scoreboard.leaseDetails && this.scoreboard.leaseDetails.driveAwayPrice) {
      if (this.scoreboard.leaseDetails.driveAwayPrice < 500000) {
        this.entityDetails.applicationValue = this.scoreboard.leaseDetails.driveAwayPrice;
        // this.scoreboard.leaseDetails.driveAwayPrice + (500000 - this.scoreboard.leaseDetails.driveAwayPrice) * 0.1;
      } else this.entityDetails.applicationValue = this.scoreboard.leaseDetails.driveAwayPrice;
      this.minValue = this.scoreboard.leaseDetails.driveAwayPrice - (500000 - this.scoreboard.leaseDetails.driveAwayPrice) * 0.1;
    }
  },
  mounted() {
    this.openFinanceDetails = this.openCollapse;
  },
  watch: {
    'openCollapse': function (newValue) {
      this.openFinanceDetails = newValue;
    },
    'entityDetails.applicationValue': function (newValue) {
      if (this.scoreboard && this.scoreboard.leaseDetails && this.scoreboard.leaseDetails.driveAwayPrice > newValue)
        this.entityDetails.applicationValue = this.scoreboard.leaseDetails.driveAwayPrice;
      if (newValue < 300000) this.entityDetails.maximum = false;
    },
    'entityDetails.maximum': function (newValue) {
      if (newValue) this.entityDetails.applicationValue = 300000;
      else this.entityDetails.applicationValue = this.minValue;
    },
    'entityDetails.purchasingMore': function (newValue, oldValue) {
      if (newValue == 'yes' && (oldValue == 'no' || !oldValue)) {
        this.entityDetails.vehicleNumber = 1;
      } else if (newValue == 'no' && (oldValue == 'yes' || !oldValue)) {
        this.entityDetails.vehicleNumber = 0;
      }
    }
  },
  data: function () {
    return {
      entityDetails: {
        fleetSize: '',
        numberEmployees: '',
        purchasingMore: '',
        vehicleNumber: 0,
        applicationValue: 40000,
        maximum: false,
        fileUrls: [],
        personallyGuarantee: ''
      },
      financeDetails: null,
      maxValue: 500000,
      minValue: 20000,
      step: 10000,
      openFinanceDetails: false,
      labelFinanceDetails: 'Other Details & Personal Guarantee',
      showFinanceDetailsDialog: false,
      fileUploadLoading: false,
      loading: false,
      saveLoading: false,
      isPersonallyGuaranteeApproved: false
    };
  },
  methods: {
    ...mapActions({
      updateVehicleApplicationState: 'vehicleApplication/updateVehicleApplicationState'
    }),
    onRejected: function (rejectedEntries) {
      alert('File size should be under 10MB.');
    },
    onPlanInfo: function () {
      this.$euiNotifications.emit({
        notification: GlobalDialog,
        // body: '<span style="color:white">If you may be considering more vehicles in the next 6 months, but are unsure select "Yes", as this may avoid the need for multiple credit applications.</span>',
        body: '<span style="color:white"> (i) If you may be considering more vehicles in the next 6 months, but are unsure select "Yes", as this may avoid the need for multiple credit applications.</span>',
        qCardStyle: {
          padding: '0',
          width: '400px',
          maxWidth: '80vw',
          backgroundColor: 'var(--primary-color)'
        },
        closeBtnStyle: {
          color: 'white'
        }
      });
    },
    onFileUploadInfo: function () {
      this.$euiNotifications.emit({
        notification: GlobalDialog,
        body:
          '<p style="color:white">Business financial statements must be prepared by an accountant for the last 2 years.</p>' +
          '<span style="color:white">Company financial can include' +
          '<ul>' +
          '<li> Balance sheet </li>' +
          '<li> Income statements </li>' +
          '</ul></span>',
        qCardStyle: {
          padding: '0',
          width: '400px',
          maxWidth: '80vw',
          backgroundColor: 'var(--primary-color)'
        },
        closeBtnStyle: {
          color: 'white'
        }
      });
    },
    currencyFormatter: function (argument) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      return formatter.format(argument);
    },
    uploadFile: async function (file, signedUrl, fileUUID, fileName, mimeType) {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', signedUrl);
      xhr.setRequestHeader('Content-Type', file.type);
      xhr.send(file);
      let self = this;
      xhr.onload = function () {
        self.entityDetails.fileUrls.push({
          uuid: fileUUID,
          fileName: fileName,
          mimeType: mimeType
        });
      };
    },
    removeFileItem: function (uuid) {
      if (this.entityDetails && this.entityDetails.fileUrls && this.entityDetails.fileUrls.length) {
        for (var i = 0; i < this.entityDetails.fileUrls.length; i++) {
          if (this.entityDetails.fileUrls[i].uuid === uuid) {
            this.entityDetails.fileUrls.splice(i, 1);
          }
        }
      }
      return;
    },
    onUpload: async function (file) {
      this.fileUploadLoading = true;
      await this.$apollo
        .mutate({
          mutation: MutateGetSignedUrl,
          variables: {
            file: file,
            shouldUpload: false
          }
        })
        .then(async (data) => {
          if (data && data.data && data.data.getSignedUrl) {
            await this.uploadFile(
              file,
              data.data.getSignedUrl.signedUrl,
              data.data.getSignedUrl.uuid,
              data.data.getSignedUrl.fileName,
              data.data.getSignedUrl.mimeType
            );
          }
          this.fileUploadLoading = false;
        })
        .catch((error) => {
          this.fileUploadLoading = false;
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
    },
    onSubmitFinanceDetails: async function () {
      if (
        this.entityDetails &&
        this.entityDetails.applicationValue >= 300000 &&
        this.entityDetails.fileUrls &&
        this.entityDetails.fileUrls.length == 0
      ) {
        this.$euiNotifications.emit({
          notification: GlobalDialog,
          noEscDismiss: true,
          persistent: true,
          body:
            '<div class="col-12" style="text-align: center">' +
            '<img src="/assets/images/alert.png" class="header-logo" />' +
            '</div>' +
            '<h4>Supporting documents required!</h4>' +
            '<span>Please upload business financial statements to support your credit limit request.</span>',
          qCardStyle: {
            padding: '0',
            width: '400px',
            maxWidth: '80vw'
          },
          closeBtnStyle: {
            display: 'none'
          },
          btnOne: {
            label: 'OK',
            outline: true,
            color: 'primary',
            action: async () => {
              return;
            }
          }
        });
        return;
      }

      if (this.entityDetails.personallyGuarantee === 'no' && !this.isPersonallyGuaranteeApproved) this.showFinanceDetailsDialog = true;
      else if (
        this.entityDetails.personallyGuarantee === 'yes' ||
        this.isSoleTrader ||
        (this.isPersonallyGuaranteeApproved && this.entityDetails.personallyGuarantee === 'no')
      ) {
        this.loading = true;
        var response = await this.submitFinanceDetails(true);
        if (response && response.data && response.data.createOrUpdateProperty && response.data.createOrUpdateProperty.status === '200') {
          this.updateVehicleApplicationState({
            value: this.financeDetails,
            propertyFirst: 'businessDetails',
            propertySecond: 'financeDetails'
          });
          setTimeout(() => {
            this.$emit('financeDetailsCompleted', true);
          });
        }
        this.loading = false;
      }
    },
    submitFinanceDetails: async function (completed = false) {
      this.financeDetails = {
        currentFleetSize: this.entityDetails.fleetSize,
        numberOfEmployees: this.entityDetails.numberEmployees,
        purchaseMoreVehicles: this.entityDetails.purchasingMore,
        howManyVehicles: this.entityDetails.vehicleNumber,
        valueOfApplication: this.entityDetails.applicationValue,
        maximum: this.entityDetails.maximum,
        fileUrls: this.entityDetails.fileUrls,
        personalGuarantee: this.entityDetails.personallyGuarantee,
        completed: completed ? 'yes' : ''
      };

      return await this.$apollo
        .mutate({
          mutation: MutateCreateOrUpdateProperty,
          variables: {
            applicationId: this.$store.getters['vehicleApplication/vehicleApplication']
              ? this.$store.getters['vehicleApplication/vehicleApplication'].applicationId
              : null,
            params: {
              value: 'financeDetails',
              financeDetails: this.financeDetails,
              propertyFirst: 'businessDetails',
              propertySecond: 'financeDetails'
            }
          }
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
    },
    saveAndClose: async function () {
      this.saveLoading = true;
      var response = await this.submitFinanceDetails();
      if (response && response.data && response.data.createOrUpdateProperty && response.data.createOrUpdateProperty.status === '200') {
        this.updateVehicleApplicationState({
          value: this.financeDetails,
          propertyFirst: 'businessDetails',
          propertySecond: 'financeDetails'
        });
        this.$router.push({ name: 'logout' });
      }
      this.saveLoading = false;
    },
    closeFinanceDetailsDialog: async function (value) {
      this.showFinanceDetailsDialog = false;
      if (value === 'continue' && !this.isPersonallyGuaranteeApproved) {
        this.isPersonallyGuaranteeApproved = true;
      } else if (value === 'continue' && this.isPersonallyGuaranteeApproved) {
        this.loading = true;
        var response = await this.submitFinanceDetails(true);
        if (response && response.data && response.data.createOrUpdateProperty && response.data.createOrUpdateProperty.status === '200') {
          this.updateVehicleApplicationState({
            value: this.financeDetails,
            propertyFirst: 'businessDetails',
            propertySecond: 'financeDetails'
          });
          setTimeout(() => {
            this.$emit('financeDetailsCompleted', true);
          });
        }
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="sass" scoped>
.blue-box
 background-color: var(--primary-color-background);
 padding: 15px;
 border-radius: 10px
.uiw-font-small-info
 color: var(--primary-color)
 top: 3px;
 position: relative;
 cursor: pointer;
</style>
